module.exports = __webpack_public_path__ + "img/image_2022_04_20T11_25_36_939Z.decb7d8e.png";